import {
    MYORDERLIST,
    MYORDERSEARCHLIST,
    MYORDERITEMDETAIL,
    REPEAT_ORDER,
    GET_CUSTOMER_ACCOUNT,
    GET_SEARCH_SC_LIST,
    MY_ORDER_SEARCH_FIELD,
    UPDATEMYORDERSEARCHLIST,
    ORDER_SEARCH_IS_LAST_PAGE,
    UPDATE_MYORDERLIST,
    UPDATE_SEARCH_TYPE_OBJ,
    SET_SALES_ONHOLD_STATUS,
    UPDATE_SALES_ORDER_PAGE_NUM,
    SET_CURRENT_ORDER_ID,
    UPDATE_UNRECEIVED_ORDER_LIST,
    SET_FROM_MY_ORDER_DETAILS,
    GET_SHIPPING_PLAN_LIST,
    UPDATE_SHIPPING_PLAN_DATA,
    UPDATE_MYORDERITEMDETAIL,
    COMPLETED_SHIPPING_PLAN,
    UPDATE_ORDER_PROOFS,
    UPDATE_MY_ORDER_PROOFS_LOCAL,
} from 'Actions/myOrder';
import update from 'immutability-helper';

let initialState = {
    myOrderList: {
        noReceive: [],
        received: [],
        canceled: [],
    },
    myOrderSearchList: [],
    myOrderItemDetail: {},
    searchSCLists: [],
    myOrderSearchfields: {
        orderE1Number: '', //订单号和E1号
        sku: '', //SKU
        scIds: [], //现货中心
        scIdsValue: [],
        institution: '', //课题组
        receiver: '', //收货人
        purchaseNo: '', //采购单
        shipTo: '', //ST#
        webAccount: '', //用户账号
        status: [], // 订单状态
        statusValue: [],
        webOrderType: [], //订单类型
        beginTime: '', //购买时间
        endTime: '',
        onHold: 0, // 暂不发货
        onHoldValue: false,
    },
    orderSearchIsLastPage: false,
    customerAccountDetail: {},
    salesOnholdStatusFlag: false,
    currentPageNum: 0,
    currentOrderId: '',
    searchTypeObj: {
        searchId: '全部',
        searchValue: null,
    },
    fromMyOrderDetails: false,
    shippingPlanDetails: [],
    addedShippingPlanData: [],
    completeShippingPlanObj: {},
};

export function myOrder(state = initialState, action) {
    let payload = {};

    switch (action.type) {
        case MYORDERLIST:
            payload.myOrderList = {};
            if (action.payload.pageNum <= 1) {
                payload.myOrderList[action.payload.tab] = action.payload.data;
            } else {
                payload.myOrderList[action.payload.tab] = state.myOrderList[
                    action.payload.tab
                ].concat(action.payload.data);
            }
            return {...state, ...payload};

        case UPDATE_UNRECEIVED_ORDER_LIST:
            console.log(action.payload);
            payload.myOrderList = {};
            payload.myOrderList[action.payload.tab] =
                action.payload.currentOrderList;
            return {...state, ...payload};

        case UPDATE_ORDER_PROOFS:
            return {
                ...state,
                ...action.payload,
            };

        case GET_SHIPPING_PLAN_LIST:
            payload.shippingPlanDetails = action.payload;
            return {...state, ...payload};

        case MY_ORDER_SEARCH_FIELD:
            return update(state, {myOrderSearchfields: action.payload});
        case UPDATEMYORDERSEARCHLIST:
            payload.myOrderSearchList = action.payload;
            return {...state, ...payload};

        case UPDATE_MYORDERLIST:
            console.log(action.payload);
            payload.myOrderList = {};
            payload.myOrderList[action.payload.tab] =
                action.payload.currentOrderList;
            return {...state, ...payload};

        case UPDATE_SEARCH_TYPE_OBJ:
            payload.searchTypeObj = {};
            payload.searchTypeObj.searchId = action.payload.searchId;
            payload.searchTypeObj.searchValue = action.payload.searchValue;
            return {...state, ...payload};

        case MYORDERSEARCHLIST:
            if (action.payload.pageNum <= 1) {
                payload.myOrderSearchList = action.payload.data;
            } else {
                payload.myOrderSearchList = state.myOrderSearchList.concat(
                    action.payload.data,
                );
            }
            return {...state, ...payload};
        case MYORDERITEMDETAIL:
            payload.myOrderItemDetail = action.payload;
            return {...state, ...payload};
        case REPEAT_ORDER:
            payload = action.payload || {};

            return Object.assign({}, state, {repeatOrder: payload});

        case GET_CUSTOMER_ACCOUNT:
            payload.customerAccountDetail = action.payload;
            return {...state, ...payload};

        case GET_SEARCH_SC_LIST:
            payload = action.payload || {};

            return Object.assign({}, state, {searchSCLists: payload});

        case SET_SALES_ONHOLD_STATUS:
            return update(state, {salesOnholdStatusFlag: action.payload});

        case UPDATE_SALES_ORDER_PAGE_NUM:
            return update(state, {currentPageNum: action.payload});

        case SET_CURRENT_ORDER_ID:
            return update(state, {currentOrderId: action.payload});

        case ORDER_SEARCH_IS_LAST_PAGE:
            return {...state, ...action.payload};

        case SET_FROM_MY_ORDER_DETAILS:
            return update(state, {fromMyOrderDetails: action.payload});

        case UPDATE_SHIPPING_PLAN_DATA:
            payload.addedShippingPlanData = action.payload;
            return {...state, ...payload};

        case UPDATE_MYORDERITEMDETAIL:
            console.log(
                'myOrderItemDetail===============================',
                action.payload,
            );
            return update(state, {myOrderItemDetail: action.payload});

        case UPDATE_MY_ORDER_PROOFS_LOCAL:
            return update(state, {
                myOrderItemDetail: {orderProofs: {$set: action.payload}},
            });

        case COMPLETED_SHIPPING_PLAN:
            payload.completeShippingPlanObj = action.payload;
            return {...state, ...payload};
        default:
            return state;
    }
}
